'use strict';

import React, { Component } from 'react'

import stripTags from 'striptags'

import { decode } from 'html-entities'

import getErrorsFromResponse from '@/Form/Functions/getErrorsFromResponse'

import Image from '@Pure/Image'
import Link  from '@Pure/Link'

const { app, qwest, moment, numeral } = window;

export default class NewPartnersNotifications extends Component
{
	state =
	{
		loading: false,

		partners: []
	};

	componentDidMount ()
	{
		const component = this, props = this.props, state = this.state;

		component.getNotifications();
	}

	getNotifications = () =>
	{
		const component = this, props = this.props, state = this.state;

		qwest.post('/notifications/get-new-partners').then(function (xhr, response)
		{
			component.setState(
			{
				partners: response.partners
			});
		})
		.catch(function (error, xhr, response)
		{
			console.error(response?.error || response?.raw || error);

			component.setState(
			{
				...getErrorsFromResponse(
				{
					response: response
				})
			});
		});
	}

	readNotification = (e, partner_id) =>
	{
		const component = this, props = this.props, state = this.state;

		qwest.post('/notifications/read',
		{
			patterns: ['new_partner_' + partner_id]
		})
		.catch(function (error, xhr, response)
		{
			console.error(response?.error || response?.raw || error);

			component.setState(
			{
				...getErrorsFromResponse(
				{
					response: response
				})
			});
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		if (state.partners.length === 0) return null;

		const partners = state.partners.map(function (partner)
		{
			let body = app.getTruncatedText(
				decode(
					stripTags(
						(partner.discount_infos || '')
						.split('&nbsp;')
						.join(' ')
						.split('</p>')
						.join('</p> ')
					)
				),
				160,
				true
			);

			const url = '/accueil/espace-partenaires/partenaires/' + partner.id;

			const output =
			(
				<Link href={ url } key={ partner.id }
					className="c-notifications__link"
					onClick={ e => component.readNotification(e, partner.id) }>

					{
						partner.logo?.[0]?.url ?
						(
							<Image className="c-notifications__thumbnail"
								src={ partner.logo[0].url }
							/>
						)
						: undefined
					}

					<div className="c-notifications__content-container">

						<span className="c-notifications__title">
							{ partner.name }
						</span>

						<span className="c-notifications__body">
							{ body }
						</span>

					</div>


				</Link>
			);

			return output;
		});

		let output =
		(
			<ul className="c-notifications c-notifications--new-partners">

				<div className="c-notifications__link">

					<span className="c-notifications__title">
						Tout derniers partenaires
					</span>

				</div>

				{ partners }

			</ul>
		);

		return output;
	}
}